/**
 * Rückfrage vor dem Schließen eines Fensters mit ungespeicherten Änderungen (#850).
 *
 * Gehört ins Fenstersystem und nicht in die App: Der Schließen-Knopf sitzt in
 * der Titelleiste, die die App gar nicht zeichnet. Apps melden über
 * `registerCloseGuard` nur an, DASS gefragt werden soll — was passiert,
 * entscheidet diese Rückfrage, und zwar der Mensch.
 */

import { useTranslation } from 'react-i18next'
import { buttonVariants } from '@/components/ui/button'
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
} from '@/components/ui/alert-dialog'
import { useWindows } from '@/hooks/useWindows'

export function WindowCloseGuardDialog() {
  const { t } = useTranslation()
  const { pendingCloseCount, pendingCloseIsAll, confirmPendingClose, cancelPendingClose } = useWindows()

  const isOpen = pendingCloseCount > 0

  return (
    <AlertDialog
      open={isOpen}
      onOpenChange={(open: boolean) => {
        // Dismissing the dialog means "don't close" — never the destructive path.
        if (!open) cancelPendingClose()
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t('window.closeGuard.title')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {pendingCloseIsAll
              ? t('window.closeGuard.descriptionAll', { count: pendingCloseCount })
              : t('window.closeGuard.description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={cancelPendingClose}>
            {t('window.closeGuard.keepOpen')}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={confirmPendingClose}
            className={buttonVariants({ variant: 'destructive' })}
          >
            {t('window.closeGuard.discard')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
